var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3PlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 90v6H31v-6c10-5 14-9 15-12h14c1 3 5 7 16 12Zm8-90-1 16c-4 22-18 47-23 57H46C40 62 24 30 22 6V0h62ZM33 57C15 48 1 28 0 8h20l1 6H11l-1 1-1 2c3 11 11 22 20 29l4 11Zm73-49c-1 20-15 40-33 49l4-11c9-7 17-18 20-30l-1-1-1-1H85l1-6h20Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 53,
    y1: 0,
    x2: 53,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D19D2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3PlaceIcon);
export default __webpack_public_path__ + "static/media/3-place-icon.7a8f7a886c3a114392d61079ae262b03.svg";
export { ForwardRef as ReactComponent };